var containers = document.querySelectorAll(
  ".ss-mega-menu-content > ul.mega-menu__list"
);
var masonryInstances = [];

document.addEventListener("DOMContentLoaded", function () {
  layoutForSmallScreens();

  containers.forEach(function (container) {
    var masonry = new Masonry(container, {
      itemSelector: ".ss-list-item",
      columnWidth: ".ss-list-item",
      gutter: 32,
      horizontalOrder: true,
      percentPosition: true,
      transitionDuration: "0.0000001s",
    });

    masonryInstances.push(masonry);
  });

  const targetElement = document.querySelector("sticky-header.header-wrapper");
  const observer = new MutationObserver(handleElementChange);
  const config = { attributes: true, childList: true, subtree: true };
  // Start observing the target element
  observer.observe(targetElement, config);
});

// Function to be executed when the target element changes
function handleElementChange(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList" || mutation.type === "attributes") {
      masonryInstances.forEach((masonry) => {
        masonry.layout();
      });
    }
  }
}

function layoutForSmallScreens() {
  var windowWidth = window.innerWidth;
  if (windowWidth >= 990 && windowWidth <= 1511) {
    reorderItems("data-sm-order");
  }
  if (windowWidth >= 1512 && windowWidth <= 1727) {
    reorderItems("data-lg-order");
  }
}

function reorderItems(order) {
  containers.forEach(function (container) {
    const parentContainer = container;
    const childElements = Array.from(parentContainer.children);
    const orderAttribute = parentContainer.getAttribute(order);
    const orderArray = orderAttribute.split(",").map(Number);

    // Check if there are more than 5 elements
    if (childElements.length > 6) {
      const defaultOrder = Array.from(
        { length: childElements.length - 6 },
        (_, index) => index + 7
      );
      orderArray.push(...defaultOrder);
    }

    // Make sure the number of elements matches the order array
    if (orderArray.length !== childElements.length) {
      console.error(
        "Number of child elements does not match the order specified."
      );
    } else {
      const reorderedElements = orderArray.map(
        (index) => childElements[index - 1]
      );
      reorderedElements.forEach((element) => {
        parentContainer.appendChild(element);
      });
    }
  });
}
